import { Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import RouteFallback from "@/components/RouteFallback/RouteFallback";
import { isCamlexHost } from "@/hooks/useEnvironment";

import { I18N_ROUTING } from "../../config/site";
import I18nRouter from "./I18nRouter";
import { Camlex } from "./lazyPages";
import MonoRouter from "./MonoRouter";

function AppRouter() {
  // On the dedicated Cam.LEX subdomain the deck is the only surface: serve it
  // at every path (a single choke point that bypasses the demo hub + language
  // prefixing). It still renders inside the BrowserRouter, so its hooks work.
  if (isCamlexHost()) {
    return (
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="*" element={<Camlex />} />
        </Routes>
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<RouteFallback />}>
      {I18N_ROUTING ? <I18nRouter /> : <MonoRouter />}
    </Suspense>
  );
}

export default AppRouter;
